import React from "react";
import NumericLabel from "react-pretty-numbers";
import { Popover, OverlayTrigger } from "react-bootstrap";

import CapSlider from "components/Project/CapSlider";
import RunFrontier from "containers/FrontierSliders/RunFrontier";
import { SubgroupTableItemGraph } from "components/Monitoring/Subgroups";

import { constructPlotFromData } from "containers/Monitoring/reducer";

import styles from "./style.module.css";

import numeral from "numeral";

import { isEnabled } from "utils/featureFlags";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { Button } from "aible";

export default class UserFeedback extends React.PureComponent {
  render() {
    const {
      userData,
      setupLabels,
      isOverallSegment,
      hasUserComplianceData,
      compliancePlot,
      businessPredictionName,
      adjustAdvancedOptions,
      isNext
    } = this.props;

    const showUserAnalytics =
      true || (businessPredictionName && businessPredictionName !== null && businessPredictionName.length > 0);
    const earliestDate = compliancePlot && compliancePlot.length > 0 && compliancePlot[0].date;
    return (
      <div className={styles.userFeedbackWrapper}>
        <div
          className={styles.userFeedbackTitle}
          style={isNext ? { fontSize: "16px", borderBottomColor: "transparent" } : undefined}
        >
          {"End User Preferences and Behavior"}
        </div>

        {!isOverallSegment ? (
          <div className={styles.userFeedbackLegend}>
            <React.Fragment>
              <LegendItem color={"#5BCF74"} label={"Thumbs Up Feedback"} />
              <LegendItem color={"#F8CD7E"} label={"Thumbs Down Feedback"} />
            </React.Fragment>
          </div>
        ) : (
          <React.Fragment />
        )}
        <div className={styles.userFeedbackBody}>
          <table className={styles.ufTable}>
            <tbody>
              <tr className={styles.ufHeader}>
                <td className={styles.ufHeaderLabel + " " + styles.ufCentered} colSpan={1}></td>
                {hasUserComplianceData && (
                  <td
                    className={styles.ufHeaderLabel + " " + styles.ufCentered + " " + styles.ufLeftDivide}
                    colSpan={1}
                  >
                    {"Current"}
                  </td>
                )}
                <td
                  className={
                    styles.ufHeaderLabel +
                    " " +
                    styles.ufCentered +
                    " " +
                    ` ${!hasUserComplianceData ? styles.ufLeftDivide : ""}`
                  }
                  colSpan={hasUserComplianceData ? 2 : 1}
                >
                  {`User Activity${earliestDate ? " since " + earliestDate : ""}`}
                </td>
                {showUserAnalytics ? (
                  <td
                    className={styles.ufHeaderLabel + " " + styles.ufCentered + " " + styles.ufLeftDivide}
                    colSpan={3}
                  >
                    {showUserAnalytics
                      ? `User Impact${earliestDate ? " since " + earliestDate : ""}`
                      : `User Analytics Not Configured`}
                  </td>
                ) : (
                  <React.Fragment />
                )}
              </tr>
              <tr className={styles.ufHeader}>
                <td className={styles.ufHeaderLabel}>{"User"}</td>
                <td className={styles.ufHeaderLabel + " " + styles.ufLeftDivide}>{"Preference"}</td>
                {hasUserComplianceData ? (
                  <React.Fragment>
                    <td className={styles.ufHeaderLabel + " " + styles.ufCentered + " " + styles.ufLeftDivide}>
                      {setupLabels.trueAction + " Followed"}
                    </td>
                    <td className={styles.ufHeaderLabel + " " + styles.ufCentered}>
                      {setupLabels.falseAction + " Followed"}
                    </td>
                  </React.Fragment>
                ) : undefined}
                {showUserAnalytics ? (
                  <React.Fragment>
                    <td className={styles.ufHeaderLabel + " " + styles.ufLeftDivide}>
                      {showUserAnalytics ? "Total Impact" : ""}
                    </td>
                    <td className={styles.ufHeaderLabel}>
                      {showUserAnalytics ? setupLabels.notPursuedTransactionLabel + " Count" : ""}
                    </td>
                  </React.Fragment>
                ) : (
                  <React.Fragment />
                  // <td
                  //   className={styles.ufHeaderLabel + " " + styles.ufLeftDivide}
                  //   style={{ textAlign: "center" }}
                  // >
                  //   <a onClick={() => adjustAdvancedOptions()}>
                  //     Go To Advanced Options
                  //   </a>
                  // </td>
                )}
              </tr>
              {userData &&
                Object.keys(userData).map((userId) => (
                  <UserPreference
                    {...this.props}
                    userId={Number(userId)}
                    currUserData={userData[userId]}
                    key={"user " + userId}
                    showUserAnalytics={showUserAnalytics}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

class LegendItem extends React.PureComponent {
  render() {
    const { color, label } = this.props;
    return (
      <div className={styles.userFeedbackLegendItem}>
        <div className={styles.userFeedbackLegendIndicator} style={{ background: color }} />
        <div className={styles.userFeedbackLegendLabel}>{label}</div>
      </div>
    );
  }
}

class UserPreference extends React.PureComponent {
  getCurrSegmentData() {
    const { currUserData, segmentId } = this.props;
    const currSegmentData = currUserData && currUserData.data && currUserData.data[segmentId];
    return currSegmentData;
  }

  getCompliance() {
    const { hasUserComplianceData } = this.props;

    const currSegmentData = this.getCurrSegmentData();
    const compliancePlot = constructPlotFromData(currSegmentData);

    if (!compliancePlot || !hasUserComplianceData) {
      return {
        totalActComplianceRate: undefined,
        totalNotActComplianceRate: undefined
      };
    }

    let retTotals = {
      complied: 0,
      notComplied: 0,
      compliedAct: 0,
      compliedNotAct: 0,
      notCompliedAct: 0,
      notCompliedNotAct: 0
    };

    compliancePlot.forEach((data) => {
      Object.keys(retTotals).forEach((k) => {
        retTotals[k] += data[k] || 0;
      });
    });

    const totalActComplianceRate = retTotals.compliedAct / (retTotals.compliedAct + retTotals.notCompliedNotAct || 1);
    const totalNotActComplianceRate =
      retTotals.compliedNotAct / (retTotals.compliedNotAct + retTotals.notCompliedAct || 1);

    return {
      totalActComplianceRate,
      totalNotActComplianceRate
    };
  }

  getImpact() {
    const { currUserData, segmentId } = this.props;
    const currSegmentScenarioData =
      currUserData && currUserData.data && currUserData.data[segmentId] && currUserData.data[segmentId].scenarios;
    const totalImpact =
      currSegmentScenarioData &&
      currSegmentScenarioData.reduce((acc, cData) => {
        const currProfit =
          cData && cData.selectedScenario && isFinite(cData.selectedScenario.profit)
            ? cData.selectedScenario.profit
            : 0;
        return acc + currProfit;
      }, 0);
    return totalImpact ? totalImpact : 0;
  }

  render() {
    const {
      currUserData,
      id,
      runId,
      userId,
      segmentId,
      setupLabels,
      isContinuous,
      isOverallSegment,
      hasUserComplianceData,
      showUserAnalytics,
      modelGroups
    } = this.props;

    if (!currUserData) {
      return;
    }

    const user = currUserData.user || {};

    const { totalActComplianceRate, totalNotActComplianceRate } = this.getCompliance();

    const segmentData = this.getCurrSegmentData();

    return (
      <tr className={styles.ufRow}>
        <td className={styles.ufItem + " " + styles.ufTitle}>{user.fullname}</td>
        <td className={styles.ufItem + " " + styles.ufPreference + " " + styles.ufLeftDivide}>
          <RunFrontier
            id={runId}
            projectId={id}
            userId={userId}
            isFeedback
            hideButton
            modelGroups={modelGroups}
            isMonitoring
            valueOverride
          />
        </td>
        {hasUserComplianceData ? (
          <React.Fragment>
            <td className={styles.ufItem + " " + styles.ufCentered + " " + styles.ufLeftDivide}>
              {totalActComplianceRate !== undefined ? numeral(totalActComplianceRate * 100).format("0.[00]") + "%" : ""}
            </td>
            <td className={styles.ufItem + " " + styles.ufCentered + " " + styles.ufRightPadding}>
              {totalNotActComplianceRate !== undefined
                ? numeral(totalNotActComplianceRate * 100).format("0.[00]") + "%"
                : ""}
            </td>
          </React.Fragment>
        ) : undefined}
        {showUserAnalytics ? (
          <React.Fragment>
            <td className={styles.ufItem + " " + styles.ufGraph + " " + styles.ufLeftDivide}>
              <SubgroupTableItemGraph
                data={segmentData && segmentData.data}
                dataKey={isContinuous ? "cost" : "impact"}
                unitType={setupLabels.unitType}
                isSmall
                isCumulative
              />
            </td>
            <td className={styles.ufItem + " " + styles.ufGraph}>
              <SubgroupTableItemGraph
                data={segmentData && segmentData.data}
                dataKey={"count"}
                isWholeNumber
                isSmall
                isCumulative
              />
            </td>
          </React.Fragment>
        ) : (
          <React.Fragment />
          // <td
          //   className={
          //     styles.ufItem + " " + styles.ufGraph + " " + styles.ufLeftDivide
          //   }
          // ></td>
        )}
      </tr>
    );
  }
}
